import { Box, Button, TextField, Typography } from "@mui/material";

const SEARCH_PLACEHOLDER = "Search this folder and everything under it";

/** Page title with the "New folder" action, plus the library-wide search box beneath it. */
const LibraryToolbar = ({
  canCreate,
  onNewFolder,
  query,
  onQueryChange,
  onSearch,
  onClear,
  activeSearch,
}) => (
  <>
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 2 }}>
      <Typography variant="h5">Document library</Typography>
      {canCreate && (
        <Button variant="contained" onClick={onNewFolder}>
          New folder
        </Button>
      )}
    </Box>
    <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
      <TextField
        size="small"
        fullWidth
        placeholder={SEARCH_PLACEHOLDER}
        value={query}
        onChange={(event) => onQueryChange(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === "Enter") onSearch();
        }}
      />
      <Button onClick={onSearch}>Search</Button>
      {activeSearch && <Button onClick={onClear}>Clear</Button>}
    </Box>
  </>
);

export default LibraryToolbar;
